import apiConfig from '../../config/api_config';

export const farmsApi = {
    getFarms: (param) => apiConfig.get('/farms/', param),
    addFarm: (data) => apiConfig.post('/farms/', data),
    getFarm: (id) => apiConfig.get(`/farms/${id}`),

};